// Side-panel menu for the top-level Configuration row, in the same shape
// as the Policies menu (policyMenu.ts): "All configuration" opens the hub;
// under category headings, each card the person can use is a shortcut to
// the page that owns the setting. Built from the hub's own catalog and
// visibility rule, so the menu and the hub can't disagree, and empty
// categories drop out. Pure, so it tests under tsx
// (configurationMenu.test.ts). AppLayout has the viewer already, so unlike
// the Policies menu no read or hook is needed.

import type { AppSidebarItem } from './apps';
import {
  CATEGORY_COPY,
  CONFIG_CARDS,
  groupCards,
  visibleCards,
  type ConfigCategory,
  type ConfigViewer,
} from '../pages/configurationHub/catalog';

// Sidebar icon keys per category (AppLayout's registry).
const CATEGORY_ICON: Record<ConfigCategory, string> = {
  organization: 'building-2',
  identity: 'key-round',
  'security-apps': 'shield',
  ai: 'sparkles',
  integrations: 'plug',
  notifications: 'send',
  data: 'archive',
};

export const ALL_CONFIGURATION: AppSidebarItem = {
  to: '/configuration',
  label: 'All configuration',
  iconKey: 'settings',
  end: true,
};

export function configurationMenuItems(viewer: ConfigViewer): AppSidebarItem[] {
  const rows: AppSidebarItem[] = [ALL_CONFIGURATION];
  for (const { category, cards } of groupCards(visibleCards(CONFIG_CARDS, viewer), '')) {
    for (const card of cards) {
      rows.push({
        to: card.href,
        label: card.title,
        iconKey: CATEGORY_ICON[category],
        group: CATEGORY_COPY[category].title,
        // The page's own menu row stays the one that lights up.
        shortcut: true,
      });
    }
  }
  return rows;
}
